/**
 * @file UserDraw.js.
 * @author Sérgio Ferraz Souza <todentro@gmail.com>
 * @copyright Cognatis GeoAnalytics & Big Data Ltda :: 2021
 */

import Service from './Service'
import Request from '../components/http/request'

const defaultJsonHeaders = {
  headers: {
    'Accept': 'application/json',
    'Cache-Control': 'no-cache',
    'Content-Type': 'application/json'
  }
}

/**
 * User Draw Management Service
 * @class
 */
class UserDraw extends Service {
  constructor (options, resource) {
    super(options)
    this.resource = resource
  }
  JsonTryParse (value) {
    try {
      return JSON.parse(value)
    } catch (e) {
      return value
    }
  }

  async getUserDrawStyle (userDrawList, type = 'all') {
    return new Promise(async (resolve, reject) => {
      if ((type === 'all') && (!userDrawList[0].hasOwnProperty('options') || userDrawList[0].options === null)) {
        reject(new Error('Objeto "options" não inicializado'))
      } else {
        switch (type) {
          case 'all':
            let style = {
              'fillOpacity': this.JsonTryParse(await this.getUserDrawStyle(userDrawList, 'fillOpacity')),
              'fillColor': this.JsonTryParse(await this.getUserDrawStyle(userDrawList, 'fillColor')),
              'lineColor': this.JsonTryParse(await this.getUserDrawStyle(userDrawList, 'lineColor')),
              'lineWidth': this.JsonTryParse(await this.getUserDrawStyle(userDrawList, 'lineWidth')),
              'lineOpacity': this.JsonTryParse(await this.getUserDrawStyle(userDrawList, 'lineOpacity'))
            }
            if (style.fillOpacity === undefined) style.fillOpacity = 0.5
            if (style.fillColor === undefined) style.fillColor = '#adadad'
            if (style.lineColor === undefined) style.lineColor = '#adadad'
            if (style.lineWidth === undefined) style.lineWidth = 0.5
            if (style.lineOpacity === undefined) style.lineOpacity = 0.5

            resolve(style)
            break
          case 'fillOpacity':
            // fill-opacity
            let fillOpacity = '["match",["get","name"],'
            for (let i = 0; i < userDrawList.length; i++) {
              let options = userDrawList[i].options
              let name = userDrawList[i].name
              if (options != undefined && options.style !== undefined && options.style != null) {
                if (options.style.paint !== undefined && options.style.paint != null) {
                  if (options.style.paint['fill-opacity'] === undefined) {
                    return undefined
                  }
                  let fillOpacityElem = `"${name}" ,${options.style.paint['fill-opacity']},`
                  fillOpacity += fillOpacityElem
                }
              }
            }
            fillOpacity = fillOpacity.slice(0, -1) + ',0.5]'
              console.log('userDrawStyle')
            console.log(fillOpacity)
            resolve(this.JsonTryParse(fillOpacity))
            break
          case 'fillColor':
            let fillColor = '["match",["get","name"],'
            for (let i = 0; i < userDrawList.length; i++) {
              let options = userDrawList[i].options
              let name = userDrawList[i].name
              if (options != undefined && options.style !== undefined && options.style != null) {
                if (options.style.paint !== undefined && options.style.paint != null) {
                  if (options.style.paint['fill-color'] === undefined) {
                    return undefined
                  }
                  let fillColorElem = `"${name}" ,"${options.style.paint['fill-color']}",`
                  fillColor += fillColorElem
                }
              }
            }
            fillColor = fillColor.slice(0, -1) + ',"rgba(255, 255, 255, 0)"]'
            resolve(this.JsonTryParse(fillColor))
            break
          case 'lineColor':
            // line-color
            let lineColor = '["match",["get","name"],'
            for (let i = 0; i < userDrawList.length; i++) {
              let options = userDrawList[i].options
              let name = userDrawList[i].name
              if (options != undefined && options.line !== undefined && options.line != null) {
                if (options.line.paint !== undefined && options.line.paint != null) {
                  if (options.line.paint['line-color'] === undefined) {
                    return undefined
                  }
                  let lineColorElem = `"${name}" ,"${options.line.paint['line-color']}",`
                  lineColor += lineColorElem
                }
              }
            }
            lineColor = lineColor.slice(0, -1) + ',"rgba(255, 255, 255, 0)"]'
            resolve(this.JsonTryParse(lineColor))
            break
          case 'lineWidth':
            // line-width
            let lineWidth = '["match",["get","name"],'
            for (let i = 0; i < userDrawList.length; i++) {
              let options = userDrawList[i].options
              let name = userDrawList[i].name
              if (options != undefined && options.line !== undefined && options.line != null) {
                if (options.line.paint !== undefined && options.line.paint != null) {
                  if (options.line.paint['line-width'] === undefined) {
                    return undefined
                  }
                  let Elem = `"${name}" ,${options.line.paint['line-width']},`
                  lineWidth += Elem
                }
              }
            }
            lineWidth = lineWidth.slice(0, -1) + ',1]'
            resolve(this.JsonTryParse(lineWidth))
            break
          case 'lineOpacity':
            // line-opacity
            let lineOpacity = '["match",["get","name"],'
            for (let i = 0; i < userDrawList.length; i++) {
              let options = userDrawList[i].options
              let name = userDrawList[i].name
              if (options != undefined && options.line !== undefined && options.line != null) {
                if (options.line.paint !== undefined && options.line.paint != null) {
                  if (options.line.paint['line-opacity'] === undefined) {
                    return undefined
                  }
                  let Elem = `"${name} ",${options.line.paint['line-opacity']},`
                  lineOpacity += Elem
                }
              }
            }
            lineOpacity = lineOpacity.slice(0, -1) + ',1]'
            resolve(this.JsonTryParse(lineOpacity))
            break
        }
      }
    })
  }

  /**
   * Update row data
   *
   * @async
   * @function update
   * @param {Number} rowId - Row identificator
   * @param {Object} options - Row options
   * @return {Promise<json>} The json with the result
   */
  async update (rowId = 0, options = {}) {
    return new Promise((resolve, reject) => {
      if (typeof options === 'undefined') reject(new Error('Esperada as opções da linha'))
      const request = new Request({tag: 'das'})
      // const request = new Request({environment: 'local', tag: 'das'})
      let endPoint = `/api/0.1-a/userdraw/${rowId}`
      request.patch(endPoint, options, defaultJsonHeaders)
        .then(response => resolve(response))
        .catch(() => reject)
    })
  }

  /**
   * Update row data
   *
   * @async
   * @function update
   * @param {Number} rowId - Row identificator
   * @param {Object} options - Row options
   * @return {Promise<json>} The json with the result
   */
  async updateOptions (rowId = 0, options = {}) {
    return new Promise((resolve, reject) => {
      if (typeof options === 'undefined') reject(new Error('Esperada as opções da linha'))
      const request = new Request({ tag: 'das'})
      // const request = new Request({environment: 'local', tag: 'das'})

      let endPoint = `/api/0.1-a/userdraw/patchuserdrawoption/${rowId}`
      request.patch(endPoint, options, defaultJsonHeaders)
        .then(response => resolve(response))
        .catch(() => reject)
    })
  }

  async getUserDrawByRequestId (requestId) {
    return new Promise((resolve, reject) => {
      const request = new Request({tag: 'das'})
      // const request = new Request({environment: 'local', tag: 'das'})
      let endPoint = `/api/0.1-a/userdraw/getuserdrawbylayer?RequestId=${requestId}`
      request.get(endPoint, defaultJsonHeaders)
        .then(response => resolve(response))
        .catch(() => reject)
    })
  }

  async save (options = {}){
    return new Promise((resolve, reject) => {
      const request = new Request({tag: 'vectorize'})
      let endPoint = `/geometry/userdraw`
      request.post(endPoint, options, defaultJsonHeaders)
        .then(res => resolve(res))
        .catch(() => reject)
    })
  }

  /**
   * Union geometries and save
   *
   * @async
   * @function update
   * @param {Object} options - Row options
   * @return {Promise<json>} The json with the result
   */
  async union (options = {}) {
    return new Promise((resolve, reject) => {
      if (typeof options === 'undefined') reject(new Error('Esperada as opções'))
      const request = new Request({tag: 'vectorize'})
      // const request = new Request({environment: 'local', tag: 'vectorize'})
      let endPoint = `/geometry/union`
      request.post(endPoint, options, defaultJsonHeaders)
        .then(res => resolve(res))
        .catch(() => reject)
    })
  }
}

export {UserDraw}
